import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaHeart, FaBell, FaEnvelope, FaUser, FaSearch, FaSignOutAlt, FaBars, FaChevronLeft, FaMoon, FaSun, FaGem, FaComments, FaShieldAlt } from 'react-icons/fa';


import { logout } from '../../store/slices/authSlice';
import { useTheme } from '../../contexts/ThemeContext';
import './Navbar.css';

const Navbar = ({ toggleSidebar, sidebarOpen, toggleSidebarCollapse, sidebarCollapsed, hamburgerToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { unreadCount: notificationsCount } = useSelector((state) => state.notifications);
  const { unreadCount: messagesCount } = useSelector((state) => state.messages);
  const { theme, toggleTheme } = useTheme();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <nav className="chatoo-navbar">
    <div className="navbar-container">
      <div className="navbar-left">
        {/* Hamburger Menu for Mobile */}
        <button
          className="navbar-hamburger"
          onClick={hamburgerToggle}
          aria-label="Toggle sidebar"
        >
          <FaBars />
        </button>

        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <FaHeart className="logo-icon" />
          <span className="logo-text">CHATOO</span>
        </Link>
      </div>

      <div className="navbar-center">
        {/* Search Bar */}
        <div className={`navbar-search ${mobileSearchOpen ? 'mobile-open' : ''}`}>
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Rechercher..."
            className="search-input"
          />
          <button type="submit" className="search-submit">
            <FaSearch />
          </button>
          <FaSearch
            className="search-icon-mobile"
            onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
          />
        </div>
      </div>

      <div className="navbar-right">
        {/* Navigation Icons */}
        <div className="navbar-icons">
          <Link to="/" className="nav-icon" title="Accueil">
            <FaHeart />
          </Link>

          <Link to="/messages" className="nav-icon" title="Messages">
            <FaEnvelope />
            {messagesCount > 0 && (
              <span className="badge">{messagesCount}</span>
            )}
          </Link>

          <Link to="/notifications" className="nav-icon" title="Notifications">
            <FaBell />
            {notificationsCount > 0 && (
              <span className="badge">{notificationsCount}</span>
            )}
          </Link>

          {/* User Menu */}
          <div className="user-menu-wrapper">
            <div
              className="nav-icon user-avatar"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
            {user?.profile?.profile_picture ? (
                <img
                  src={user.profile.profile_picture}
                  alt={user.full_name}
                  className="avatar-img"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" style="width: 24px; height: 24px;"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>';
                  }}
                />
              ) : (
                <FaUser />
              )}

            </div>

            {showUserMenu && (
              <div className="user-dropdown">
                <Link
                  to={`/profile/${user?.id}`}
                  className="dropdown-item"
                  onClick={() => setShowUserMenu(false)}
                >
                  <FaUser /> Mon Profil
                </Link>
                <Link
                  to="/dashboard"
                  className="dropdown-item"
                  onClick={() => setShowUserMenu(false)}
                >
                  <FaHeart /> Dashboard
                </Link>
                <Link
                  to="/wallet"
                  className="dropdown-item"
                  onClick={() => setShowUserMenu(false)}
                >
                  <FaGem /> Mon Portefeuille
                </Link>
                
                {/* Admin Links */}
                {(user?.role === 'admin' || user?.role === 'superadmin') && (
                  <>
                    <div className="dropdown-divider"></div>
                    <div className="dropdown-section-title">Administration</div>
                    <Link
                      to="/admin/discussions"
                      className="dropdown-item"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <FaComments /> Discussions
                    </Link>
                    <Link
                      to="/admin/dashboard"
                      className="dropdown-item"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <FaShieldAlt /> Dashboard Admin
                    </Link>
                  </>
                )}
                
                <div className="dropdown-divider"></div>


                <button
                  className="dropdown-item logout-btn"
                  onClick={handleLogout}
                >
                  <FaSignOutAlt /> Déconnexion
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </nav>
  );
};

export default Navbar;
